import { render, staticRenderFns } from "./SmallSegment.vue?vue&type=template&id=b2e11c42&scoped=true&"
import script from "./SmallSegment.vue?vue&type=script&lang=ts&"
export * from "./SmallSegment.vue?vue&type=script&lang=ts&"
import style0 from "./SmallSegment.vue?vue&type=style&index=0&id=b2e11c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e11c42",
  null
  
)

export default component.exports